<template>
  <v-app v-bind:style="{ 'background-image': 'url(' + hammannBackground + ')',
  'background-repeat': 'no-repeat', 'background-size': 'auto', 'background-attachment': 'fixed' }">
    <v-toolbar dark color="purple" app>
      <v-toolbar-title class="headline text-uppercase">
        <span>Hammann Line Bot</span>
        <span class="font-weight-light"></span>
        <v-btn
          color="black"
          dark
          @click.stop="drawer = !drawer"
        >
          Menu
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://www.patreon.com/hammann"
        target="_blank"
      >
        <span class="mr-2">Patreon</span>
        <v-icon>open_in_new</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content>
      <v-navigation-drawer
        v-model="drawer"
        :mini-variant="mini"
        absolute
        dark
        temporary
        >
          <v-list class="pa-1">
            <v-list-tile v-if="mini" @click.stop="mini = !mini">
              <v-list-tile-action>
                <v-icon>chevron_right</v-icon>
              </v-list-tile-action>
            </v-list-tile>

            <v-list-tile avatar tag="div">
              <v-list-tile-avatar>
                <img :src="require('./assets/hammann-sleep.png')">
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>Hammann rank: 225</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-btn icon @click.stop="mini = !mini">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>

          <v-list class="pt-0" dense>
            <v-divider light></v-divider>

      <v-list-group v-for="group in groups" :key="group.title" :prepend-icon="group.icon" :value="false">
        <template v-slot:activator>
          
            <v-list-tile>
              <router-link v-if="group.route" :to="group.route">
                <v-list-tile-title>{{ group.title }}</v-list-tile-title>
              </router-link>
              <v-list-tile-title v-else>{{ group.title }}</v-list-tile-title>
            </v-list-tile>
          
        </template>

          <v-list-group sub-group no-action v-for="c in group.commands" :key="c.title" :value="false">
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>{{ c.title }}</v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-group no-action v-for="command in c.commands" :key="command.title">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-title>{{ command.title }}</v-list-tile-title>
                </v-list-tile>
              </template>
            </v-list-group>
 
          </v-list-group>


      </v-list-group>
            
          </v-list>
        </v-navigation-drawer>

      <v-container fluid>
        <router-view/>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { commands } from './plugins/commands'
export default {
  name: 'App',
  data: () => ({
    drawer: false,
    mini: false,
    groups: commands,
    hammannBackground: require('./assets/bakground-hammann.jpg')
  })
}
</script>

<style>
.v-list__tile a {
  color: azure
}
</style>
